<lib-starbase-wizard #reportsWizard
  [open]="true"
  [initialObject]="filter"
  [wizardTitle]="'Generate Tonnage Report'"
  [theSteps]="generateTonnageReportSteps"
  [darkMode]="darkMode"
  (completedEmitter)="generateReport($event)"
  (cancelEmitter)="wizardCancelledEmitter.emit()">
  <ng-content></ng-content>
</lib-starbase-wizard>

<ng-template #step1 let-wrapperForm = "wrapperForm">
  <div [ngClass]="{'defaultMode': !darkMode,'darkMode': darkMode}" style="min-height: 500px;">
    <div style="flex-wrap: wrap; width: 100%; margin-top: 10px;">
      <h3 style="text-align: center;">
        {{reportTitle}} - Criteria Selection
      </h3>
    </div>
    <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
      <div style="min-width: 750px;">
        <div style="width: 40%; text-align: end; display: inline-block;">
          <label style="margin-top: 8px;" *ngIf="!isSeasonal">Scale Ticket Date Range:</label>
          <label style="margin-top: 8px;" *ngIf="isSeasonal">Report Year:</label>
        </div>
        <div style="display: inline-block;">
          <div class="input-group input-group-sm" style="width: 15em; margin-left: 1em;" *ngIf="!isSeasonal">
            <input [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy') + ' - ' + (filterDateTo | date: 'MM/dd/yyyy') : ''"
              placeholder="Date Range" id="dateRange" name="dateRange"
              #scaleticketDateRange
              bsDaterangepicker
              [bsConfig]="bsConfig"
              (bsValueChange)="dateRangeChange($event)"
              style="min-width: 300px;"
              class="form-control"
              [ngClass]="{'btn-dark': darkMode}"
              aria-describedby="cal-addon"
              matTooltip="Set a scale ticket date range filter"
              aria-label="Scale Ticket Dash Date Range">
          </div>
          <div class="input-group input-group-sm" style="width: 15em; margin-left: 1em;" *ngIf="isSeasonal">
            <input type="number" style="min-width: 300px;" step="1" [value]="year" id="year" name="year" [(ngModel)]="year" (input)="setYear()">
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
      <div style="min-width: 750px; text-align: center;">
        <span style="color: red;" *ngIf="displayDateRangeWarning()">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</span>
      </div>
    </div>
    <!--<div class="row" style="justify-content: center; margin-bottom: 0.5em;">
      <div style="height: 40px; min-width: 750px;">
        <label style="width: 40%; text-align: end; margin-right: 1em;" [matTooltip]="'Leave blank to include ALL Statuses'">Scale Ticket Statuses: </label>
        <div class="btn-group dropdown" matTooltipPosition="above" matTooltip="Filter by Statuses">
          <button type="button" id="statusDropMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="btn btn-sm dropdown-toggle" style="min-width: 300px;"
            [ngClass]="{'btn-dark': darkMode, 'btn-outline-secondary': !darkMode}">
            <span class="badge bg-dark" *ngIf="filterStatus.length">{{ filterStatus.length }}</span>
            {{ filterStatus.length == 0 ? 'All Statuses' : 'Statuses'}}
          </button>
          <div class="dropdown-menu" [ngClass]="{'darkMode':darkMode}" style="max-height: 200px; overflow: auto;" aria-labelledby="statusDropMenu">
            <a class="dropdown-item" [ngClass]="{'disabled': !filterStatus.length,'darkMode':darkMode}" (click)="filterStatus = []; updateCustomers();">
              All Statuses
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" *ngFor="let s of statuses" (click)="updateStatuses(s.value)">
              <i class="fal fa-check me-1" *ngIf="filterStatus.includes(s.value)"></i>
              <span class="statusBadge" [style.color]="s.statusColor">
                {{ s.key }}
              </span>
            </a>
          </div>
        </div>
        <mat-form-field style="width: 40%;">
          <mat-select [ngClass]="{'darkMode': darkMode}" [(ngModel)]="filterStatus" matTooltip="Filter by Invoice Status" class="filterDropDown selectpicker" multiple>
            <mat-option value="0" selected>{{ filterStatus && filterStatus !== null ? 'Clear Invoice Status Filter' : 'Clear Statuses' }}</mat-option>
            <mat-option *ngFor="let status of statuses" [value]="status.value" (click)="this.updateCustomers()">{{ status.key }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>-->
    <div class="row" style="justify-content: center;">
      <div style="height: 40px; min-width: 750px;">
        <label style="width: 40%; text-align: end; margin-right: 1em;" [matTooltip]="'Leave blank to include ALL Materials'">Materials: </label>
        <div class="btn-group dropdown" matTooltipPosition="above" matTooltip="Filter by Materials">
          <button type="button" id="materialDropMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="btn btn-sm dropdown-toggle" style="min-width: 300px;"
            [ngClass]="{'btn-dark': darkMode, 'btn-outline-secondary': !darkMode}">
            <span class="badge bg-dark" *ngIf="filterMaterial.length">{{ filterMaterial.length }}</span>
            {{ filterStatus.length == 0 ? 'All Materials' : 'Materials'}}
          </button>
          <div class="dropdown-menu" [ngClass]="{'darkMode':darkMode}" style="max-height: 200px; overflow: auto;" aria-labelledby="materialDropMenu">
            <a class="dropdown-item" [ngClass]="{'disabled': !filterMaterial.length,'darkMode':darkMode}" (click)="filterMaterial = []; updateCustomers();">
              All Materials
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" *ngFor="let m of materials" (click)="updateMaterials(m)">
              <i class="fal fa-check me-1" *ngIf="filterMaterial.includes(m)"></i>
              {{ m.materialServiceCode }} - {{ m.unitOfMeasure.unitOfMeasure }}
            </a>
          </div>
        </div>
        <!--<mat-form-field style="width: 40%;" class="no-border">
          <mat-select [ngClass]="{'darkMode': darkMode}" [(ngModel)]="filterMaterial" matTooltip="Material&Service" class="filterDropDown selectpicker" multiple>
            <mat-option value="0" selected>{{ filterMaterial && filterMaterial !== null ? 'Clear Material Filter' : 'Clear Materials' }}</mat-option>
            <mat-option *ngFor="let material of materials" [value]="material.uid" (click)="this.updateCustomers()">{{ material.materialServiceCode }} - {{ material.unitOfMeasure.unitOfMeasure }}</mat-option>
          </mat-select>
        </mat-form-field>-->
      </div>
    </div>

    <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
      <div style="height: 40px; min-width: 750px;">
        <div>
          <label style="width: 40%; text-align: end; margin-right: 1em;">Customer(s): </label>
          <div style="display: inline-block;">
            <b style="margin-right: 1em;">{{ customers.length == 0 || customers.length == allCustomers.length ? "All Customers" : (customers.length == 1 ? customers[0].organization : (customers.length + ' Customers')) }}</b>
            <button class="headerButton" (click)="openCustomerSelection()" matTooltip="Select Customer" matTooltipPosition="right" style="float: right;">
              <i class="far fa-address-book"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
      <div style="height: 40px; min-width: 750px;">
        <div>
          <label style="width: 40%; text-align: end; margin-right: 1em;">Jobs: </label>
          <div style="display: inline-block;">
            <b style="margin-right: 1em;">{{ jobs.length == 0 || jobs.length == allJobs.length ? "All Jobs" : (jobs.length == 1 ? jobs[0].jobDescription : (jobs.length + ' Jobs')) }}</b>
            <button class="headerButton" (click)="openJobSelection()" matTooltip="Select Jobs" matTooltipPosition="right" style="float: right;">
              <i class="far fa-address-book"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #step2 let-wrapperForm="wrapperForm">
  <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
    <div title="Please wait..." class="ball-pulse">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <lib-customer-select #customerSelect *ngIf="!isProcessing"
            [darkMode]="darkMode"
            [currentCustomers]="customers"
            [dateRange]="!showAll ? [filterDateFrom, filterDateTo] : []"
            [stStatus]="filterStatus"
            [customerSvc]="contactSvc"
            (selectionEmitter)="selectCustomer($event)"
            (selectionUpdatedEmitter)="selectAllCustomers()">
            Select Customer for {{reportTitle}}
  </lib-customer-select>
</ng-template>

<ng-template #step3 let-wrapperForm="wrapperForm">
  <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
    <div title="Please wait..." class="ball-pulse">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <lib-job-select #jobSelect *ngIf="!isProcessing"
              [darkMode]="darkMode"
              [currentJobs]="jobs"
              [selectedCustomers]="customers"
              [customers]="customers"
              [jobCodes]="jobCodes"
              [jobCategories]="jobCategories"
              [jobDataSvc]="jobSvc"
              [sbSvcProvider]="sbSvcProvider"
              [appGlobals]="appGlobals"
              [reportMode]="true"
              [sites]="sites"
              (selectionEmitter)="selectJob($event)">
              Select Jobs for {{reportTitle}}
  </lib-job-select>
</ng-template>

<!-- [mainColor]="mainColor"
    [darkMode]="darkMode"
    [glassMode]="glassMode"
    [tooltipDelay]="tooltipDelay"
    [currentJobs]="jobs"
    [selectedCustomers]="customers"
    [selectedSite]="invoiceBatch.site"
    [dateRange]="!showAll ? [dateRangeStart, dateRangeEnd] : []"
    [batchMode]="true"
    [customers]="customers"
    [jobCodes]="jobCodes"
    [jobCategories]="jobCategories"
    [sites]="sites"
    [jobDataSvc]="jobSvc"
    [sbSvcProvider]="sbSvcProvider"
    [appGlobals]="appGlobals"
    (selectionEmitter)="selectJob($event)">
    Select Jobs for Invoice Batch -->

<div *ngIf="selectCustomerMode" class="dialogBox dashModule" [ngClass]="{'darkMode':darkMode}" style="padding-left: 0; padding-right: 0; padding-bottom: 0; height: auto;">
  <div class="scaleTicketRow" style="justify-content: center;" [ngClass]="{'darkMode':darkMode}">
    <h4 class="boxTitle" style="text-align: center;">
      <i class="fal fa-fw fa-address-book"></i> Manage Customer Selections
    </h4>
    <button matTooltip="Close" style="position: absolute; right: 0.5em; top: 0.5em;" (click)="closeCustomerSelectComponent()" class="btn btn-outline-secondary">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="card-body" style="padding-top: 0;" [ngClass]="{'darkMode':darkMode}">
    <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
      <div title="Please wait..." class="ball-pulse">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <lib-customer-select #customerSelect *ngIf="!isProcessing"
      [darkMode]="darkMode"
      [currentCustomers]="customers"
      [dateRange]="!showAll ? [filterDateFrom, filterDateTo] : []"
      [stStatus]="filterStatus"
      [customerSvc]="contactSvc"
      (selectionEmitter)="selectCustomer($event)"
      (selectionUpdatedEmitter)="selectAllCustomers()"
      (hardSelectionEmitter)="closeCustomerSelectComponent(true,$event)">
      Select Customer for {{reportTitle}}
    </lib-customer-select>
  </div>
  <div class="btn-group w-100" role="group">
    <button class="btn btn-outline-warning no-radius" type="button" (click)="closeCustomerSelectComponent()">
      <i class="fal fa-times"></i>
        Close
    </button>
    <button class="btn btn-success no-radius" type="button" (click)="closeCustomerSelectComponent(true)" [disabled]="customers.length == 0">
      <i class="fal fa-check"></i>
        Select
    </button>
  </div>
</div>


<div *ngIf="selectJobMode" class="dialogBox dashModule" [ngClass]="{'darkMode':darkMode}" style="padding-left: 0; padding-right: 0; padding-bottom: 0; height: auto;">
  <div class="scaleTicketRow" style="justify-content: center;" [ngClass]="{'darkMode':darkMode}">
    <h4 class="boxTitle" style="text-align: center;">
      <i class="fal fa-fw fa-address-book"></i> Manage Job Selections
    </h4>
    <button matTooltip="Close" style="position: absolute; right: 0.5em; top: 0.5em;" (click)="closeJobSelectComponent()" class="btn btn-outline-secondary">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="card-body" style="padding-top: 0;" [ngClass]="{'darkMode':darkMode}">
    <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
      <div title="Please wait..." class="ball-pulse">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <lib-job-select #jobSelect *ngIf="!isProcessing"
                [darkMode]="darkMode"
                [currentJobs]="jobs"
                [selectedCustomers]="customers"
                [customers]="customers"
                [jobCodes]="jobCodes"
                [jobCategories]="jobCategories"
                [jobDataSvc]="jobSvc"
                [sbSvcProvider]="sbSvcProvider"
                [appGlobals]="appGlobals"
                [reportMode]="true"
                [sites]="sites"
                (selectionEmitter)="selectJob($event)"
                >
                Select Jobs for {{reportTitle}}
    </lib-job-select>
  </div>
  <div class="btn-group w-100" role="group">
    <button class="btn btn-outline-warning no-radius" type="button" (click)="closeJobSelectComponent()">
      <i class="fal fa-times"></i>
        Close
    </button>
    <button class="btn btn-success no-radius" type="button" (click)="closeJobSelectComponent(true)" [disabled]="customers.length == 0">
      <i class="fal fa-check"></i>
        Select
    </button>
  </div>
</div>
